$(document).ready(function(){
    'use strict'

    function findVideos() {
        let videos = document.querySelectorAll('.video');

        for (let i = 0; i < videos.length; i++) {
            setupVideo(videos[i]);
        }
    }

    function setupVideo(video) {
        let link = video.querySelector('.video__link');
        let media = video.querySelector('.video__media');
        let button = video.querySelector('.video__button');
        let id = parseMediaURL(media);

        video.addEventListener('click', () => {
            let iframe = createIframe(id);

            link.remove();
            button.remove();
            video.appendChild(iframe);
        });

        link.removeAttribute('href');
        video.classList.add('video--enabled');
    }

    function parseMediaURL(media) {
        let regexp = /https:\/\/i\.ytimg\.com\/vi\/([a-zA-Z0-9_-]+)\/maxresdefault\.jpg/i;
        let url = media.src;
        let match = url.match(regexp);

        return match[1];
    }

    function createIframe(id) {
        let iframe = document.createElement('iframe');

        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('allow', 'autoplay');
        iframe.setAttribute('src', generateURL(id));
        iframe.classList.add('video__media');

        return iframe;
    }

    function generateURL(id) {
        let query = '?rel=0&showinfo=0&autoplay=1';

        return 'https://www.youtube.com/embed/' + id + query;
    }

    function cleaningVideoList () {
        let videos = document.querySelectorAll('.video-list__el');

        for (let i = 0; i < videos.length; i++) {
            videos[i].remove();
        }
    }

    function addVideoElement () {
        let videoList = document.querySelector('.video-list');

        videoList.insertAdjacentHTML('beforeend', '<p>Пока</p>');
        videoList.insertAdjacentHTML('beforeend', '<p>Привет</p>');
    }

    $.ajax({
        type: "GET",
        url: "/ajax/get-videos",
        success: function (data) {
            console.log('get-videos successful')
        }
    });

    const data = ["7TreP3H-FXg","LgrvBlaIRiE","mHszADZdICE","veLyXboI7E0","Dgnspvq4m9E","gpQis4gIIKM","Y3hyyaevpV4","z0uoxKrq1pU","l3AdfkxTNUs","xWvKdSc1m8c","hRO2LBv7NHQ","EL2Q06_AijI","FP4c3QDmVVs","jGmaVUAv8xI","7Xd-WH0XKwQ","jJUuCLkAsiY","oIFdYj6yfi8","GO5PxAzThi4","Mu_fLx2iMhQ","jbBf2j07Q2Q","ndldOFoljlI","YJOxBM3Ek30","48pFVoqHBoc","546a8XksXPM","-RD7oBFefJY","tDYgPyaUhbc","2-2guGP4pbA","5OZJFltJ1kI","zpihbQrSr8s","Z5ayI_8djtc","7hITT_09wLw","w3jtYjZM9sA","NW19Yrfy-OM","MuWFZJFemDU","LFkON9wyE6I","wSzOMZzuzRA","-VcDQQwkeAw","yMeICa7BKYY","TILdWK_gIi0","B4q4Y7aG0BQ","bOXKUaFg4IE","g7ESPJxVUFc","w6u7-Sxaam8","JxAdRtSHWBw","aD51gdgIF9s","D3kqh3FU3zo","FwfoePM0UHU","8TVo7IeLu8s","qvVE6WJ23bA","geZIpg4oUiU","IvkbVKGuETo","0D6nQD_iBLk","H4MWM4nGZ_4","ujux272Uuiw","5umMlmbw0mc","We1KXY74s8U","gc-00nh-nA0","dfSEEpgagWE","xgmIodvoOfs","ykVOYU3061s","fToKel44UoE"]

    setTimeout(function () {
        // cleaningVideoList();
        // addVideoElement();
    }, 1000)

    findVideos();
});
